module.exports = __webpack_public_path__ + "img/logo.060eb38d.png";